import { WipType } from "../enums.generated";
import { BuildRowLinkTemplateArgs } from "../models/data-grid";
import { urlDataFormat } from "./string";

/**
 * Handler for building broker report row links.
 * @param args Args object containining necessary grid row information.
 * @returns The relevant URL.
 */
export function onBrokerReportGridBuildRowLinkTemplate (args: BuildRowLinkTemplateArgs) {
	console.log(args);
	let template: string;
	if (args.dataItem.mtaId) {
		template = args.urlService.url("MTA/Details/(mtaId)");
	}
	else if (args.dataItem.drawdown) {
		template = args.options.rowLinkTemplate;
	}
	else {
		template = args.urlService.url("Agreement/(contract)");
	}
	return urlDataFormat(template, args.dataItem);
}